import script from "./submitters_autocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./submitters_autocomplete.vue?vue&type=script&setup=true&lang=js"

import "./submitters_autocomplete.vue?vue&type=style&index=0&id=7e8d1a03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e8d1a03"]])

export default __exports__